import { useAuthStore } from '~~/stores/auth'
export default defineNuxtRouteMiddleware(async (_to, _from) => {
  const authStore = useAuthStore()
  const fromPath = _to.query?.from as string | undefined

  // If this is an invite link and we have a logged-in user, force logout
  if (_to.path.startsWith('/invite/') && authStore.user) {
    const { logout } = useAuth()
    await logout(null)
    return
  }

  if (authStore.user)
    return navigateTo(fromPath ?? authStore.defaultUserPage)
})
